import React, { useEffect, useState } from "react";
import PlotSerivce from "../../../services/plot.service";
import { TFarmDataResponse } from "../../../services/farm.service";
import SpeedoMetersContainer from "../../../global-components/SpeedoMetersContainer";
import { t } from "../../../services/locale.service";

type TProps = {
  plotId: string;
}

const DiseaseSpeedoMeters: React.FC<TProps> = (props) => {
  const { plotId } = props;

  const [diseasePredictions, setDiseasePredictions] = useState<TFarmDataResponse>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    fetchDiseasePredictions();
  }, []);

  const fetchDiseasePredictions = async () => {
    try {
      setIsLoading(true);
      const response = await PlotSerivce.getDiseasePrediction(plotId);

      const farmData = {} as TFarmDataResponse;
      
      response.forEach(data => {
        // Safety check to ensure data exists and has required properties
        if (!data || typeof data !== "object") {
          console.warn("Invalid data item:", data);
          return;
        }

        const hasSpeedoMeterLabels = data?.labels && Array.isArray(data.labels) && data.labels.length > 0;
        const hasSpeedoMeterValue = data.value !== undefined && data.value !== null;

        const hasSpeedoMeterDetails = hasSpeedoMeterLabels && hasSpeedoMeterValue;
        if(hasSpeedoMeterDetails) {
          // Convert colors to grayscale if not applicable
          const processedLabels = data.isApplicable === false 
            ? (data.labels || []).map(label => ({
              ...label,
              labelColor: "#808080", // Gray
              activeBarColor: "#808080" // Gray
            }))
            : (data.labels || []);

          const diseaseId = data?.oldDiseaseId ?? "";
          
          farmData[diseaseId] = {
            value: data?.value ?? 0,
            maxValue: data.maxValue ?? 0,
            minValue: data.minValue ?? 0,
            description: data.description ?? "",
            labels: processedLabels,
            color: data.displayName,
            isApplicable: data.isApplicable,
          };
        }
      });
      setDiseasePredictions(farmData);

    } catch(error) {
      console.error(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  if(isError){
    return <p style={{textAlign: "center"}}>{t("Something_went_wrong")}</p>;
  }

  if(isLoading){
    return <p style={{textAlign: "center"}}>{t("Loading_Disease_Sensors")}</p>;
  }
  return (
    <div>
      {
        <SpeedoMetersContainer
          farmData={diseasePredictions}
          speedoMeterFor="disease"
          plotId={plotId}
        />
      }  
    </div>
  );
};

export default DiseaseSpeedoMeters;